import { render, staticRenderFns } from "./TechDetail.vue?vue&type=template&id=de849ca8&scoped=true&"
import script from "./TechDetail.vue?vue&type=script&lang=js&"
export * from "./TechDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de849ca8",
  null
  
)

export default component.exports